<script>
  export let contributors;
  export let advisors;
</script>

<style lang="scss">
  .acknowledgement {
    max-width: 800px;
    margin: 0 auto;
    margin-bottom: 5rem;
    padding: 1.5rem;
  }

  h4 {
    font-size: 1.6rem;
    margin: 1.5rem 0 1rem 0;

    &:not(:first-child) {
      margin-top: 5rem;
    }
  }

  ul {
    margin-left: 2rem;
  }

  li {
    font-size: 1.3rem;
    font-weight: 300;
    margin: 1rem 0;
  }
</style>

<section class="acknowledgement">
  <h4>คณะผู้จัดทำ</h4>
  <ul>
    {#each contributors as { team, members }}
      <li>{team} : {members}</li>
    {/each}
  </ul>

  <h4>ขอขอบคุณคณะผู้เชี่ยวชาญและที่ปรึกษา</h4>
  <ul>
    {#each advisors as { name, org }}
      <li>{name} - {org}</li>
    {/each}
  </ul>
</section>
